export default "__VITE_ASSET__ChBSFAZl__"